export const BP_EDIT_EXIT_SHEET_SHOWN_FPTI = {
  eventName: 'bp_edit_exit_sheet_shown',
}

export const CONFIRM_EXIT_EDIT_BUTTON_CLICKED = {
  eventName: 'bp_edit_exit_sheet_back_click',
}

export const CANCEL_EXIT_EDIT_BUTTON_CLICKED = {
  eventName: 'bp_edit_exit_sheet_stay_click',
}
